/**
 * Registers the names achievements.ts prints for cosmetic unlocks ("building:palmHouse" → "Palm House").
 * achievements.ts cannot import the skin registries itself (they import the achievements graph back), so the
 * UI registers this once at start-up — importing this module is enough.
 */
import { setUnlockNamer } from "./achievements";
import { buildingSkin, floorSkin } from "./houseSkins";
import { shelfSkin } from "./shelfSkins";
import { potSkin } from "./potSkins";
import { decorKeyName, speciesName } from "./speciesDecor";
import { avatarFrame } from "./avatar";
import { fenceStyle } from "./fenceStyles";

setUnlockNamer((kind, id) => {
  if (kind === "plant" || kind === "fish" || kind === "insect") return speciesName(`${kind}:${id}`);
  if (kind === "building") return buildingSkin(id).name;
  if (kind === "floor") return floorSkin(id).name;
  if (kind === "shelf") return shelfSkin(id).name;
  if (kind === "pot") return potSkin(id).name;
  if (kind === "frame") return avatarFrame(id).name;
  if (kind === "fence") return fenceStyle(id).name;
  return decorKeyName(id);
});
